export type LocalNativeBuild = {
  buildId: string;
  builtAt: string;
  bundleIdentifier: string;
};

export function readLocalNativeBuild(
  value: unknown,
  bundleIdentifier: string,
): LocalNativeBuild | null {
  if (
    value === null ||
    typeof value !== "object" ||
    !("buildId" in value) ||
    typeof value.buildId !== "string" ||
    value.buildId.length === 0 ||
    !("builtAt" in value) ||
    typeof value.builtAt !== "string" ||
    !Number.isFinite(Date.parse(value.builtAt)) ||
    !("bundleIdentifier" in value) ||
    value.bundleIdentifier !== bundleIdentifier
  ) {
    return null;
  }
  return { buildId: value.buildId, builtAt: value.builtAt, bundleIdentifier };
}

export function getNativeBuildStatus(
  installedBuildId: string | null,
  latest: LocalNativeBuild | null,
) {
  if (installedBuildId === null) {
    return {
      label: "⚠︎ vpx _ios",
      outdated: false,
      text: "NATIVE UNSTAMPED — rebuild with vpx _ios",
    };
  }
  const installed = installedBuildId.slice(0, 8);
  if (latest === null) {
    return {
      label: `▣ ${installed} ?`,
      outdated: false,
      text: `NATIVE ${installed} — latest build unverified`,
    };
  }
  const builtAt = new Date(latest.builtAt).toLocaleString("en-US", { hour12: false });
  if (installedBuildId !== latest.buildId) {
    return {
      label: `▣ ${installed}→${latest.buildId.slice(0, 8)}`,
      outdated: true,
      text: `OUTDATED NATIVE ${installed} → ${latest.buildId.slice(0, 8)} (${builtAt}) — vpx _ios`,
    };
  }
  return {
    label: `▣ ${installed} ✓`,
    outdated: false,
    text: `NATIVE ${installed} current · built ${builtAt}`,
  };
}
